import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import Greek translations
import commonEL from './locales/el/common.json';
import ordersEL from './locales/el/orders.json';
import deliveryEL from './locales/el/delivery.json';
import productsEL from './locales/el/products.json';
import settingsEL from './locales/el/settings.json';
import analyticsEL from './locales/el/analytics.json';
import adminEL from './locales/el/admin.json';
import orgPagesEL from './locales/el/orgPages.json';
import superadminOpsEL from './locales/el/superadminOps.json';
import superAdminPanelEL from './locales/el/superAdminPanel.json';
import dineInEL from './locales/el/dineIn.json';
import kitchenEL from './locales/el/kitchen.json';
import printingEL from './locales/el/printing.json';
import authEL from './locales/el/auth.json';
import takeawayEL from './locales/el/takeaway.json';
import warehouseEL from './locales/el/warehouse.json';
import customersEL from './locales/el/customers.json';
import storePromotionsEL from './locales/el/storePromotions.json';
import floorEditorEL from './locales/el/floorEditor.json';
import reservationsEL from './locales/el/reservations.json';
import depositsEL from './locales/el/deposits.json';
import employeesEL from './locales/el/employees.json';
import catalogEL from './locales/el/catalog.json';
import homeEL from './locales/el/home.json';
import orgDashboardEL from './locales/el/orgDashboard.json';
import fiscalDocumentsEL from './locales/el/fiscalDocuments.json';
import posTerminalsEL from './locales/el/posTerminals.json';
import storePlatformsEL from './locales/el/storePlatforms.json';
import listPageEL from './locales/el/listPage.json';
import callsEL from './locales/el/calls.json';
import storeOrdersEL from './locales/el/storeOrders.json';
import storeWasteEL from './locales/el/storeWaste.json';
import dailyDishesEL from './locales/el/dailyDishes.json';

// Import English translations
import commonEN from './locales/en/common.json';
import ordersEN from './locales/en/orders.json';
import deliveryEN from './locales/en/delivery.json';
import productsEN from './locales/en/products.json';
import settingsEN from './locales/en/settings.json';
import analyticsEN from './locales/en/analytics.json';
import adminEN from './locales/en/admin.json';
import orgPagesEN from './locales/en/orgPages.json';
import superadminOpsEN from './locales/en/superadminOps.json';
import superAdminPanelEN from './locales/en/superAdminPanel.json';
import dineInEN from './locales/en/dineIn.json';
import kitchenEN from './locales/en/kitchen.json';
import printingEN from './locales/en/printing.json';
import authEN from './locales/en/auth.json';
import takeawayEN from './locales/en/takeaway.json';
import warehouseEN from './locales/en/warehouse.json';
import customersEN from './locales/en/customers.json';
import storePromotionsEN from './locales/en/storePromotions.json';
import floorEditorEN from './locales/en/floorEditor.json';
import reservationsEN from './locales/en/reservations.json';
import depositsEN from './locales/en/deposits.json';
import employeesEN from './locales/en/employees.json';
import catalogEN from './locales/en/catalog.json';
import homeEN from './locales/en/home.json';
import orgDashboardEN from './locales/en/orgDashboard.json';
import fiscalDocumentsEN from './locales/en/fiscalDocuments.json';
import posTerminalsEN from './locales/en/posTerminals.json';
import storePlatformsEN from './locales/en/storePlatforms.json';
import listPageEN from './locales/en/listPage.json';
import callsEN from './locales/en/calls.json';
import storeOrdersEN from './locales/en/storeOrders.json';
import storeWasteEN from './locales/en/storeWaste.json';
import dailyDishesEN from './locales/en/dailyDishes.json';

export const defaultNS = 'common';
export const resources = {
  el: {
    common: commonEL,
    orders: ordersEL,
    delivery: deliveryEL,
    products: productsEL,
    settings: settingsEL,
    analytics: analyticsEL,
    admin: adminEL,
    orgPages: orgPagesEL,
    superadminOps: superadminOpsEL,
    superAdminPanel: superAdminPanelEL,
    dineIn: dineInEL,
    kitchen: kitchenEL,
    printing: printingEL,
    auth: authEL,
    takeaway: takeawayEL,
    warehouse: warehouseEL,
    customers: customersEL,
    storePromotions: storePromotionsEL,
    floorEditor: floorEditorEL,
    reservations: reservationsEL,
    deposits: depositsEL,
    employees: employeesEL,
    catalog: catalogEL,
    home: homeEL,
    orgDashboard: orgDashboardEL,
    fiscalDocuments: fiscalDocumentsEL,
    posTerminals: posTerminalsEL,
    storePlatforms: storePlatformsEL,
    listPage: listPageEL,
    calls: callsEL,
    storeOrders: storeOrdersEL,
    storeWaste: storeWasteEL,
    dailyDishes: dailyDishesEL,
  },
  en: {
    common: commonEN,
    orders: ordersEN,
    delivery: deliveryEN,
    products: productsEN,
    settings: settingsEN,
    analytics: analyticsEN,
    admin: adminEN,
    orgPages: orgPagesEN,
    superadminOps: superadminOpsEN,
    superAdminPanel: superAdminPanelEN,
    dineIn: dineInEN,
    kitchen: kitchenEN,
    printing: printingEN,
    auth: authEN,
    takeaway: takeawayEN,
    warehouse: warehouseEN,
    customers: customersEN,
    storePromotions: storePromotionsEN,
    floorEditor: floorEditorEN,
    reservations: reservationsEN,
    deposits: depositsEN,
    employees: employeesEN,
    catalog: catalogEN,
    home: homeEN,
    orgDashboard: orgDashboardEN,
    fiscalDocuments: fiscalDocumentsEN,
    posTerminals: posTerminalsEN,
    storePlatforms: storePlatformsEN,
    listPage: listPageEN,
    calls: callsEN,
    storeOrders: storeOrdersEN,
    storeWaste: storeWasteEN,
    dailyDishes: dailyDishesEN,
  },
} as const;

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('store_language') || 'el',
    fallbackLng: 'el',
    defaultNS,
    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

export default i18n;
